import { createState } from 'shared'
import { ForManagingTeamMembers, GuardInput } from 'core'

interface TeamMember {
	email: string
	role: string
}

const { state: teamMembersState, updateState: updateTeamMembers } = createState<
	TeamMember[]
>([])

const { state: formErrorsState, updateState: updateFormErrors } = createState<
	Record<string, string | undefined>
>({})

const setFormErrors = (field: string, error: string | undefined) => {
	updateFormErrors(prev => ({
		...prev,
		[field]: error
	}))
}

export const setTeamMemberEmail = (index: number, email: string) => {
	if (email === '') {
		setFormErrors(`email-${index}`, '')
		updateTeamMembers(prev => {
			const updated = [...prev]
			if (!updated[index]) {
				updated[index] = { email: '', role: '' }
			}
			updated[index] = { ...updated[index], email: '' }
			return updated
		})
		return
	}

	const emailErrorField = GuardInput.check(
		ForManagingTeamMembers.AddTeamMember.partial(),
		{
			email
		}
	)

	if (emailErrorField) {
		setFormErrors(`email-${index}`, emailErrorField?.inputErrors?.email)
	} else {
		setFormErrors(`email-${index}`, '')
	}

	updateTeamMembers(prev => {
		const updated = [...prev]
		if (!updated[index]) {
			updated[index] = { email: '', role: '' }
		}
		updated[index] = { ...updated[index], email }
		return updated
	})
}

export const setTeamMemberRole = (index: number, role: string) => {
	updateTeamMembers(prev => {
		const updated = [...prev]

		if (!updated[index]) {
			updated[index] = { email: '', role: '' }
		}

		updated[index] = { ...updated[index], role }
		return updated
	})
}

export { teamMembersState, formErrorsState }
